let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iiJxA")).then(() => parcelRequire('f6qTx'));